<template>
  <v-card
    :class="{
      'white--text': isDarkTheme,
    }"
    :style="cardStyle"
    @click="showProfiles"
  >
    <v-row dense row wrap>
      <v-col class="body-1 pt-2 pb-0 hyp-title-container col-12">
        <span class="pull-left hyp-header application-heading breakText">
          {{ item.facility_name }}
        </span>
      </v-col>
    </v-row>
    <v-row dense row wrap>
      <v-col class="body-2 pb-0 hyp-title-container col-12">
        {{ item.city }}, {{ item.country }}
      </v-col>
    </v-row>
    <v-row dense row wrap>
      <v-col class="body-2 pb-0 hyp-title-container col-12">
        Number of Travelers:
        <span class="application-heading">{{
          new Set(item.segments.map((x) => x.profile_id)).size
        }}</span>
      </v-col>
    </v-row>
    <v-row dense row wrap>
      <v-col class="body-2 pb-2 hyp-title-container col-12">
        Number of VIPs:
        <span class="application-heading">{{
          [...new Set(item.segments.map((x) => x.profile_id))].filter(
            (x) => x.is_vip
          ).length
        }}</span>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { GET_DETAILS_SIDEBAR } from "@/store/actions.type";
import { DETAIL_SIDEBAR_TYPES } from "@/common/constants/home";
import { MODULE_PREFIX_HOME } from "@/store";

import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";

export default {
  name: "TravelTrackerListClusterItem.vue",
  props: {
    item: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({ detailsSidebar: MODULE_PREFIX_HOME + "detailsSidebar" }),
    cardStyle() {
      return this.isDarkTheme ? null : { padding: "0 8px" };
    },
    isDarkTheme() {
      return false;
    },
  },
  methods: {
    async showProfiles() {
      this.detailsSidebar.segments = this.item.segments;
      this.detailsSidebar.visible = true;
      this.detailsSidebar.loading = true;
      this.detailsSidebar.selected = DETAIL_SIDEBAR_TYPES.isosProfiles;
      this.detailsSidebar.type = DETAIL_SIDEBAR_TYPES.isosProfiles;

      this.handlePageTrackerEvent(
        EVENT_CATEGORIES.isos,
        EVENT_ACTIONS.clicked,
        "Result Card"
      );

      await this.$store.dispatch(
        MODULE_PREFIX_HOME + GET_DETAILS_SIDEBAR,
        this.detailsSidebar
      );
    },
  },
};
</script>

<style scoped>
.type-icon {
  font-size: 0.75rem;
  padding-right: 3px;
}

.vip {
  justify-content: flex-end;
}

.item-header {
  justify-content: space-between;
}
</style>
